<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="ID">
              <el-input v-model="queryParams.id" @change="search" placeholder="请输入ID" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="手机号">
              <el-input v-model="queryParams.phone" @change="search" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="预约酒店">
              <el-input v-model="queryParams.hotel_name" @change="search" placeholder="请输入酒店名字" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="审核状态">
              <el-select v-model="queryParams.status" @change="search" placeholder="请选择状态" clearable style="width:100%">
                <el-option label="待审核" :value="0"></el-option>
                <el-option label="审核通过" :value="1"></el-option>
                <el-option label="审核驳回" :value="2"></el-option>
                <el-option label="已失效" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="reset" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="getList">刷新列表</el-button>
      </div>
      <MyTable
          ref="myTableRef"
          :table-data="tableData"
          :columns="columns"
          :loading="loading"
          :total="total"
          :page-no="queryParams.pageNo"
          :page-size="queryParams.pageSize"
          @pagination-change="paginationChange"
      >
        <template #status="{ scope }">
          <el-tag :type="statusType(scope.row.status)" size="small">{{ scope.row.status_text }}</el-tag>
        </template>
        <template #operation>
          <el-table-column fixed="right" label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == 0" type="text" size="medium" @click="openAudit(scope.row)">审核</el-button>
              <span v-else style="color:#909399;">—</span>
            </template>
          </el-table-column>
        </template>
      </MyTable>

      <!-- 审核弹窗 -->
      <el-dialog title="预约审核" :visible.sync="auditVisible" width="460px" append-to-body>
        <el-form label-width="90px" size="medium">
          <el-form-item label="预约用户">{{ current.username || '-' }}（{{ current.phone || '-' }}）</el-form-item>
          <el-form-item label="预约酒店">{{ current.hotel_name || '-' }}</el-form-item>
          <el-form-item label="预约时间">{{ current.created_at || '-' }}</el-form-item>
          <el-form-item label="审核结果">
            <el-radio-group v-model="auditForm.status">
              <el-radio :label="1">审核通过</el-radio>
              <el-radio :label="2">审核驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核备注">
            <el-input type="textarea" v-model="auditForm.audit_remark" :rows="3" maxlength="255" show-word-limit
                      placeholder="可填写审核备注"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="auditVisible = false">取消</el-button>
          <el-button type="primary" :loading="submitting" @click="submitAudit">提交</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { rcApis } from "@/api/rc";
import { processErrors } from "@/utils/errorHandler";
const api = rcApis();
export default {
  data() {
    return {
      columns: [
        { label: 'ID', prop: 'id', width: '70' },
        { label: '预约用户', prop: 'username', width: '120' },
        { label: '手机号', prop: 'phone', width: '130' },
        { label: '预约酒店', prop: 'hotel_name', showOverflowTooltip: true },
        { label: '审核状态', prop: 'status', slotKey: 'status', width: '100' },
        { label: '审核备注', prop: 'audit_remark', showOverflowTooltip: true },
        { label: '预约时间', prop: 'created_at', width: '160' },
      ],
      queryParams: { pageNo: 1, pageSize: 10, id: '', phone: '', hotel_name: '', status: '' },
      tableData: [],
      total: 0,
      loading: false,
      auditVisible: false,
      submitting: false,
      current: {},
      auditForm: { id: '', status: 1, audit_remark: '' },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    statusType(s) {
      if (s == 1) return 'success';   // 审核通过
      if (s == 2) return 'danger';    // 审核驳回
      if (s == 3) return 'info';      // 已失效
      return 'warning';               // 待审核
    },
    getList(type) {
      this.loading = true;
      if (type != 'changePage') this.queryParams.pageNo = 1;
      api.AppointmentList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.totalCount;
        } else {
          processErrors(res);
        }
        this.loading = false;
      });
    },
    paginationChange({ pageNo, pageSize }) {
      this.queryParams.pageNo = pageNo;
      this.queryParams.pageSize = pageSize;
      this.getList('changePage');
    },
    search() { this.getList(); },
    reset() {
      this.queryParams = { pageNo: 1, pageSize: 10, id: '', phone: '', hotel_name: '', status: '' };
      this.getList();
    },
    openAudit(row) {
      this.current = row;
      this.auditForm = {
        id: row.id,
        status: row.status == 2 ? 2 : 1,
        audit_remark: row.audit_remark || '',
      };
      this.auditVisible = true;
    },
    submitAudit() {
      this.submitting = true;
      api.AppointmentAudit(this.auditForm).then(res => {
        this.submitting = false;
        if (res.code == 0) {
          this.$message.success('审核完成');
          this.auditVisible = false;
          this.getList('changePage');
        } else {
          processErrors(res);
        }
      }).catch(() => { this.submitting = false; });
    },
  },
}
</script>
<style lang='scss' scoped>
.el-card__body { padding: 0px !important; }
.btn_left { margin-left: 100px; }
.div_buttom { width: 100%; display: flex; margin-bottom: 20px; }
</style>
